/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_RequiredInputs */

const en_ui_thresholds_required = /** @type {(inputs: Ui_Thresholds_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

const de_ui_thresholds_required = /** @type {(inputs: Ui_Thresholds_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderlich`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Ui_Thresholds_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_required = /** @type {((inputs?: Ui_Thresholds_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_required(inputs)
	return de_ui_thresholds_required(inputs)
});